import React from 'react';
import styled, {css} from 'styled-components';
import {
    DARK_MODE_BACKGROUND,
    DARK_MODE_BORDER,
    DARK_MODE_BORDER_COLOR,
    DARK_MODE_COMMON_TEXT_COLOR,
    DARK_MODE_HEADER_BACKGROUND,
    DARK_MODE_HOVER_BACKGROUND,
    DARK_MODE_SIDER_BACKGROUND,
    DARK_MODE_TABLE_BORDER,
    DARK_MODE_TABLE_BORDER_COLOR,
    DARK_MODE_TABLE_HEADER,
    DARK_MODE_TEXT_COLOR
} from "../../constants/colorScheme";

const BasicLayoutContainer = styled.div`
    .logo {
        height: 32px;
        background: rgba(255, 255, 255, 0.2);
        margin: 16px;
    }
        
    .app-content {
        margin-top: ${props => props.isExtraSmall ? '96': '48'}px;
    }
    
    .navbar-container {
        position:fixed;
        width:100%;
        left:0;
        top:0;
        right: 0;
        height: ${props => props.isExtraSmall ? '96': '48'}px;
        z-index: 1000;
    }
    
    .main-table .ant-table-column-sorters::after {
        width: 0;
    }
    
   ${props => props.darkMode && css`
   
    .ant-layout, .ant-layout-footer {
        background: ${DARK_MODE_BACKGROUND}
    }
    
    .ant-layout-header {
        background-color: ${DARK_MODE_HEADER_BACKGROUND} !important        
    }
    
    .ant-layout-header .ant-typography, .ant-layout-header .header-container {
        color: ${DARK_MODE_COMMON_TEXT_COLOR} !important
    }
    
    .ant-pagination-jump-prev 
    .ant-pagination-item-container 
    .ant-pagination-item-ellipsis, 
    
    .ant-pagination-jump-next 
    .ant-pagination-item-container 
    .ant-pagination-item-ellipsis {
        color: ${DARK_MODE_TEXT_COLOR};
    }

    .basic-title {
        color: ${DARK_MODE_TEXT_COLOR} !important        
    }
    
    .ant-table-wrapper {
        background-color: ${DARK_MODE_HEADER_BACKGROUND} !important          
    }    
    
    .ant-form-item-label label {
        color: ${DARK_MODE_TEXT_COLOR} !important         
    }
    
    .ant-form-item-control-input input {
        background-color: transparent !important;
        // border: ${DARK_MODE_BORDER};     
        color: ${DARK_MODE_TEXT_COLOR};   
    }
        
    .ant-picker, .ant-input {
        border: ${DARK_MODE_BORDER};             
    }
    .ant-form-item-has-error .ant-input-number, .ant-form-item-has-error .ant-picker {
        background-color: transparent;
    }
    .ant-form-item-has-error .ant-input-number:not([disabled]):hover, .ant-form-item-has-error .ant-picker:not([disabled]):hover {
        background-color: transparent;
    }
    
    .ant-steps {    
        color: rgba(255,255,255,.65);
    }
    .ant-steps-item-title {
        color: ${DARK_MODE_COMMON_TEXT_COLOR} !important          
    }
    
    .ant-steps-item-description {
        color: ${DARK_MODE_COMMON_TEXT_COLOR} !important          
    }
    
    .ant-steps-item-wait .ant-steps-item-icon {
        background-color: transparent;
        border-color: rgba(255,255,255,.3);
        .ant-steps-icon {
            color: ${DARK_MODE_COMMON_TEXT_COLOR}            
        }
    }
    
    .ant-steps-item-finish .ant-steps-item-icon,
    .ant-steps-item-error .ant-steps-item-icon {
        background-color: transparent;
    }
    
    // card    
    .ant-card, .ant-table {
        background: transparent;
    }
    
    .ant-card-head {
        background-color: ${DARK_MODE_HEADER_BACKGROUND} !important;
    }
    
    .ant-card-head-wrapper {
        border-bottom: ${DARK_MODE_BORDER} !important;          
    }
    
    .ant-card-body {
        background-color: ${DARK_MODE_HEADER_BACKGROUND} !important           
    }
    
    .ant-card-head-title {
        color: ${DARK_MODE_TEXT_COLOR} !important          
    }
    .ant-card-bordered {
        border: ${'none'};
    }
    //card
    
    //table 
    .ant-table-thead th {
        background-color: ${DARK_MODE_TABLE_HEADER} !important;
        color: ${DARK_MODE_TEXT_COLOR} !important;
    }  
    .ant-table-cell {
        background-color: ${DARK_MODE_TABLE_HEADER} !important; 
        color: ${DARK_MODE_COMMON_TEXT_COLOR}         
    }
    .software-product-tag {
        background: ${DARK_MODE_HEADER_BACKGROUND};
        color: ${DARK_MODE_COMMON_TEXT_COLOR};
        border: ${DARK_MODE_BORDER};
    }
    .ant-empty-description {
        color: ${DARK_MODE_TEXT_COLOR} !important;        
    }
    .ant-table-thead > tr > th {
        border-bottom: ${'0px'};
    }
    .ant-table-thead .ant-input {
        background-color: ${DARK_MODE_TABLE_HEADER} !important;  
        color: ${DARK_MODE_TEXT_COLOR} !important;     
    }
    .date-input { 
        border: ${DARK_MODE_BORDER} !important;    
    }   
    .ant-picker {
        background: transparent;
    }
    
    .ant-table-thead .ant-input-affix-wrapper
    {
        background-color: ${DARK_MODE_TABLE_HEADER} !important;  
        border: ${DARK_MODE_BORDER} !important;      
    }    
    .ant-table-thead .ant-input-affix-wrapper svg {
        color: ${DARK_MODE_COMMON_TEXT_COLOR} !important;
    }
    .ant-table-thead .ant-input-affix-wrapper input {
        background-color: ${DARK_MODE_TABLE_HEADER} !important;  
        color: ${DARK_MODE_TEXT_COLOR} !important;      
    }
     
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background-color: ${DARK_MODE_HOVER_BACKGROUND} !important;
    }
    .ant-table-tbody>tr>td {
        border-bottom: ${DARK_MODE_TABLE_BORDER} !important;
    }
    
    .ant-pagination-item-link {
        background: transparent !important;
    }
    
    .ant-pagination-item a {
        background-color: ${DARK_MODE_HEADER_BACKGROUND} !important;
        color: ${DARK_MODE_TEXT_COLOR} !important;        
    }
    .ant-pagination-item-link svg {
        color: ${DARK_MODE_TEXT_COLOR} !important;                
    }
    .ant-pagination-item-active {
        background-color: ${'unset'} !important;        
    }      
        
    .table-row-light {
        background-color: #141414};
        color: rgba(255,255,255,.65)}
    }
    
    .table-row-dark, .table-row-dark td.ant-table-column-sort {
        background-color: #000000};
        color: rgba(255,255,255,.65)}
    }
    
    .ant-select-item-option {
        color: ${DARK_MODE_TEXT_COLOR}
    }
    
    .main-table .ant-select-clear {
        color: #fff;
        background: inherit;
    }
    
    //table
        
    .ant-layout-sider-children {
        padding-top: 15px;
        background-color: ${DARK_MODE_SIDER_BACKGROUND} !important;        
    }
    .ant-layout-sider {
        background-color: ${DARK_MODE_SIDER_BACKGROUND} !important;   
    }    
    .ant-layout-sider-trigger {
        color: ${DARK_MODE_TEXT_COLOR} !important;
    }   
    
    .ant-menu-dark, .ant-layout-sider-trigger {
        background-color: ${DARK_MODE_SIDER_BACKGROUND} !important;         
    }
        
    // result page
    .ant-result-title, .ant-result-subtitle {
        color: ${DARK_MODE_COMMON_TEXT_COLOR} !important           
    }
    // result page
    
    .ant-select-selector {
        background-color: ${DARK_MODE_TABLE_HEADER} !important;   
        color: ${DARK_MODE_TEXT_COLOR} !important;   
        border: ${DARK_MODE_BORDER} !important;      
    }
    .ant-select-selector svg {  
        color: ${DARK_MODE_TEXT_COLOR} !important;                     
    }
    
    .ant-select-dropdown {
        background-color: ${DARK_MODE_TABLE_HEADER} !important; 
    }
    
    // statistic
    .ant-statistic-content, .ant-statistic-title { 
        color: ${DARK_MODE_COMMON_TEXT_COLOR};           
    }
    .ant-typography {
        color: ${DARK_MODE_TEXT_COLOR};         
    }
    
    // statistic
    
    // scrollbar
    .ant-table-body::-webkit-scrollbar {
        background-color: ${DARK_MODE_BACKGROUND}; 
    }
    .ant-table-body::-webkit-scrollbar-track {
        background-color: ${DARK_MODE_HEADER_BACKGROUND}; 
    }
    .ant-table-body::-webkit-scrollbar-thumb {
        background-color:  ${DARK_MODE_SIDER_BACKGROUND}; 
        border: 3px solid transparent;
        border-radius: 9px;
        background-clip: content-box;
    }
    // scrollbar
    
    .ant-breadcrumb-link a {
        color: ${DARK_MODE_TEXT_COLOR} !important; 
    }
    
    .ant-btn:not(.ant-btn-primary) {
        background: transparent;
        color: ${DARK_MODE_COMMON_TEXT_COLOR};
    }
        
    .ant-tag-close-icon {color: ${DARK_MODE_COMMON_TEXT_COLOR};}
    .ant-tag-close-icon:hover {color: ${DARK_MODE_TEXT_COLOR};}
    
    .ant-input-number {
        color: rgba(255,255,255,.65);
        background-color: transparent;
        border: 1px solid #434343;
    }
    .ant-input-number-handler-wrap {
        background: #141414;
        border-left: 1px solid #434343;
    }
    
    .ant-divider-horizontal.ant-divider-with-text {
        color: rgba(255,255,255,.65);
        border-top-color: rgba(255,255,255,.12);
    }
    
    // descriptions
    .ant-descriptions-bordered .ant-descriptions-view {
        border: 1px solid #303030;
    }
    
    .ant-descriptions-title { 
        color: ${DARK_MODE_COMMON_TEXT_COLOR};
    }    
    
    .ant-descriptions-bordered .ant-descriptions-item-label {
        background-color: #1d1d1d !important;
        color: ${DARK_MODE_COMMON_TEXT_COLOR} !important;
    }
    .ant-descriptions-bordered .ant-descriptions-item-label, .ant-descriptions-bordered .ant-descriptions-item-content {
        border-right: 1px solid ${DARK_MODE_TABLE_BORDER_COLOR};
    }
    .ant-descriptions-bordered .ant-descriptions-row {
        border-bottom: 1px solid ${DARK_MODE_TABLE_BORDER_COLOR};
    }
    .ant-descriptions-item-label {
        color: ${DARK_MODE_COMMON_TEXT_COLOR}
    }
    .ant-descriptions-item-content {
        color: ${DARK_MODE_TEXT_COLOR}
    }
    // descriptions
    
    // collapse
    .ant-collapse {
        border: none;
    }
    .ant-collapse > .ant-collapse-item {
        border-bottom: none;
    }
    
    .ant-collapse .ant-collapse-content,
    .ant-collapse .ant-collapse-header {
        background: ${DARK_MODE_HEADER_BACKGROUND} !important;
        color: ${DARK_MODE_TEXT_COLOR} !important;
        border: ${DARK_MODE_BORDER}
    }
    
    .ant-input-group-addon {
        border-color: #434343;
    }      

    ::placeholder,
    input::placeholder,
    .ant-select-selection-placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${DARK_MODE_BORDER_COLOR} !important;
        opacity: 1; /* Firefox */
    }
   
   `}
    
`;

export default BasicLayoutContainer;